export const GET_CLIENT_SUMMARY = 'GET_CLIENT_SUMMARY';
export const GET_CLIENT_SUMMARY_SUCCESS = 'GET_CLIENT_SUMMARY_SUCCESS';
export const SAVE_CLIENT_SUMMARY = 'SAVE_CLIENT_SUMMARY';
export const CLIENT_SUMMARY_ERROR = 'CLIENT_SUMMARY_ERROR';
